import { useEffect, useState } from 'react';
import { updateCp } from '../../redux/cp/cpSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getFechaEntregaEstimada } from '../../utils/envios';

const useHook = () => {
  const dispatch = useDispatch();
  const reduxCp = useSelector((state: any) => state.cp.cp);
  const [cp, setCp] = useState("");
  const [loading, setLoading] = useState(false);
  const [shippingsAndreani, setShippingsAndreani] = useState<any>(null);
  const [open, setOpen] = useState(true);

  const fechaEntrega = getFechaEntregaEstimada();

  const handleChange = (e: string) => {
    if (/^\d{0,4}$/.test(e)) {
      setCp(e);
      if (e.length === 4) {
        dispatch(updateCp(e));
      }
    }
  };

  const handleClean = () => {
    dispatch(updateCp(""));
    setCp("");
  };

  const toggleOpen = () => setOpen((prev) => !prev);

  async function getShipments(cp: string) {
    setLoading(true);
    // Se limpian los resultados de la consulta anterior antes de pedir los
    // nuevos: si no, al cambiar de código postal y no encontrar una opción
    // (p.ej. Andreani sin cobertura para el nuevo CP), quedaba pisado el
    // precio/opción del CP anterior en vez de desaparecer.
    setShippingsAndreani(null);
    const body = {
      cp: cp,
    };
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/envios/cotizar3`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (result) {
        const andreaniResults = result.andreani;
        const filteredAndreaniResults = andreaniResults?.find((envio: any) => envio.modoDeEntrega === "A domicilio");
        setShippingsAndreani(filteredAndreaniResults ?? null);
        if (!filteredAndreaniResults) {
          console.error("Error al filtrar envíos de Andreani", andreaniResults);
        }
      } else {
        console.error("Error al obtener datos de Andreani", result);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setCp(reduxCp);
    if (typeof window !== 'undefined' && reduxCp?.length === 4) {
      getShipments(reduxCp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reduxCp]);

  return {
    cp,
    reduxCp,
    loading,
    shippingsAndreani,
    fechaEntrega,
    handleChange,
    handleClean,
    open,
    toggleOpen,
  };
};

export default useHook;
